import React, { useContext, useEffect } from "react";
import "./guestRegisterPage.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Container } from "react-bootstrap";
import { GuestRegisterContext } from "../GuestRegisterView";
import Button from "../../../components/ButtonComponent/Button";
import TextInput from "../../../components/TextInputComponent/TextInput";
import UploadIcon from "../../../assets/images/uploadIcon.svg";
import CameraIcon from "../../../assets/images/cameraIcon.svg";
import DropDownArrow from "../../../assets/images/dropdownArrow.svg";
import DropdownList from "../../../constants/contentFile.json";
import DropDownSearch from "../../../components/DropDownSearchComponent/DropDown";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
import CameraUpload from "../../../components/CameraUpLoadComponent/CameraUpload";
import AlerBox from "../../../components/AlertComponent/AlertBox";
import { Spinner } from "react-bootstrap";
import { number } from "prop-types";
const GuestRegisterPage = ({ textContents }) => {
  const {
    guestType,
    setGuestType,
    magneticId,
    guestName,
    setGuestName,
    contactNo,
    setContactNo,
    category,
    setCategory,
    emergencyContactNo,
    setEmergencyContactNo,
    purposeOfVisit,
    setPurposeOfVisit,
    location,
    setLocation,
    company,
    setCompany,
    vehicleNo,
    setVehicleNo,
    magneticCardCode,
    fromPlace,
    setFromPlace,
    visitorType,
    setVisitorType,
    guestNameRequired,
    contactNoRequired,
    categoryRequired,
    emergencyContactNoRequired,
    purposeOfVisitRequired,
    locationRequired,
    companyRequired,
    vehicleNoRequired,
    fromPlaceRequired,
    visitorTypeRequired,
    validateGuestRegister,
    guestPhotoRequired,
    guestListRequired,
    guestPhoto,
    setGuestPhoto,
    guestList,
    setGuestList,
    goBack,
    isCamera,
    setIsCamera,
    modalOpenStatus,
    setModalOpenStatus,
    categoryList,
    visitorTypeList,
    alertMessage,
    showAlert,
    setShowAlert,
    logout,
    displayName,
    VisitorName,
    isEdit,
    setMagneticId,
    assignedTo,
    setAssignedTo,
    idProof,
    setIdProof,
    photoLabel,
    pdfFileLabel,
    setPhotoLabel,
    setPdfFileLabel,
    setIndividual,
    setGuest,
    changeable,
    inavalidIdProof,
    setInavalidIdProof,
    magneticCardIdRequired,
    setMagneticCardIdRequired,
    idORPhotoOptional,
    setIdORPhotoOptional,
    magneticListData,
    magneticCardList,
    cameraLabel,
    alertBack,
    statusCode,
    setCameraLabel,
    visitorSpinnerStatus,
  } = useContext(GuestRegisterContext);

  useEffect(() => {
    magneticListData();
  }, []);

  return (
    <div className="outerContainerGuestRegister">
      <TopBar />

      <AlerBox
        alertMessage={alertMessage}
        show={showAlert}
        setShow={setShowAlert}
        handleSubmit={
          statusCode == 401
            ? () => {
                logout();
              }
            : () => alertBack()
        }
      />

      <Container className="innerContainerGuestRegister">
        <div className="containerRegisterGuest">
          <div className="magneticIdContainerRegister">
            <span className="magneticIdTextGuestRegister">
              {textContents.magneticId} {magneticId}
            </span>
          </div>
          <div className="guestRegisterContainer">
            <span className="guestRegisterText">
              {isEdit ? displayName : textContents.guestRegister}
            </span>
          </div>
          <div className="checkContainerGuestRegister">
            <div
              className="checkIndividualGuestRegister cursor-pointer"
              onClick={() => {
                changeable != "G" && setIndividual();
              }}
            >
              {guestType == "I" ? (
                <div className="checkInGuestRegister"></div>
              ) : null}
            </div>
            <span
              className="individualTextGuestRegister"
              onClick={() => {
                changeable != "G" && setIndividual();
              }}
            >
              {textContents.individual}
            </span>
            <div
              className="checkGroupGuestRegister"
              onClick={() => {
                changeable != "I" && setGuest();
              }}
            >
              {guestType == "G" ? (
                <div className="checkInGuestRegister"></div>
              ) : null}
            </div>
            <span
              className="individualTextGuestRegister"
              onClick={() => {
                changeable != "I" && setGuest();
              }}
            >
              {textContents.group}
            </span>
          </div>
          <div className="formOuterContainerGuest">
            <div className="formInnerContainerGuest">
              <div className="formFieldOuterContainerRegister">
                <div className="fieldOuterContainerRegister">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.guestName}
                      </span>
                    </div>
                    <div
                      className={
                        guestNameRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={guestName}
                        value={guestName}
                        type={"text"}
                        // onChange={(e) => {
                        //   setGuestName(e.target.value);
                        // }}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/^ |[^a-zA-Z\s]/g, "");
                          setGuestName(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.emergency}
                      </span>
                      <span className="fieldNametextRegister">
                        {textContents.contactNo}
                      </span>
                    </div>
                    <div
                      className={
                        emergencyContactNoRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={emergencyContactNo}
                        type={"number"}
                        maxLength={10}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-", "."].includes(e.key) &&
                          e.preventDefault()
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                        value={emergencyContactNo}
                        onChange={(e) => {
                          setEmergencyContactNo(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.company}
                      </span>
                    </div>
                    <div
                      className={
                        companyRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={company}
                        value={company}
                        type={"text"}
                        onChange={(e) => {
                          setCompany(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister ">
                        {textContents.magneticId}
                      </span>
                    </div>
                    <div
                      className={
                        magneticCardIdRequired === true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <DropDownSearch
                        IsSearch={true}
                        selectedItem={magneticId ? magneticId : "Select"}
                        //disabled={isEditRole && true}
                        setSelectedItem={setMagneticId}
                        list={magneticCardCode}
                        categoryRequired={magneticCardIdRequired}
                        //isEdit={isEditRole}
                      />
                      {/* <TextInput
                        placeholder={magneticId}
                        value={magneticId}
                        type={"number"}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-", "."].includes(e.key) &&
                          e.preventDefault()
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                        onChange={(e) => {
                          setMagneticId(e.target.value);
                        }}
                      /> */}
                    </div>
                  </div>
                </div>
                <h5 className="field-margin-top">Upload Photo Or ID Proof</h5>
                <div className="fieldOuterContainerRegister">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.addPhoto}
                      </span>
                    </div>
                    <div className="fieldValuePhotoRegister">
                      <label
                        // onClick={(event) => {
                        //   event.target.value = null;
                        // }}
                        className={
                          inavalidIdProof === true
                            ? "uploadPhotoContainerGuest"
                            : "uploadPhotoContainerGuest uploadPhotoContainerGuestError"
                        }
                      >
                        <img src={UploadIcon} alt="img" />
                        <span className="uploadTextRegister">
                          {textContents.upload}
                        </span>
                        <input
                          className="default-btn"
                          type={"file"}
                          accept="image/jpeg, image/png, application/pdf"
                          onChange={(e) => {
                            let selectedFile = e.target.files[0];
                            const acceptedFiles = [
                              "image/png",
                              "image/jpeg",
                              "image/jpg",
                              "application/pdf",
                            ];
                            if (
                              selectedFile &&
                              acceptedFiles.indexOf(selectedFile.type) === -1
                            ) {
                              setPhotoLabel("");
                              setGuestPhoto(false);
                            } else {
                              setPhotoLabel(e?.target?.files[0]?.name);

                              setGuestPhoto(e?.target?.files[0]);
                            }
                          }}
                        />
                      </label>
                      <button
                        className={
                          inavalidIdProof === true
                            ? "cameraContainerGuest"
                            : "cameraContainerGuest uploadPhotoContainerGuestError"
                        }
                        onClick={() => {
                          setPhotoLabel(null);
                          setModalOpenStatus(true);
                          setGuestPhoto(guestPhoto);
                          // setCameraLabel(guestPhoto.name);
                        }}
                      >
                        <img src={CameraIcon} alt="img" />
                        <span className="uploadTextRegister">
                          {textContents.camera}
                        </span>
                      </button>
                      <br />
                      {photoLabel === "" ? (
                        <p className="imageNameGuest">{photoLabel}</p>
                      ) : (
                        <p className="imageNameGuest">{guestPhoto?.name}</p>
                      )}
                      {photoLabel !== "" ? (
                        <p className="imageNameGuest">{photoLabel}</p>
                      ) : (
                        <p className="imageNameGuest">{guestPhoto.name}</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="fieldOuterContainerRegister">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.addPhoto}
                      </span>
                    </div>
                    <div className="fieldValuePhotoRegister">
                      <label
                        className={
                          guestPhotoRequired == true
                            ? "uploadPhotoContainerGuest"
                            : "uploadPhotoContainerGuest uploadPhotoContainerGuestError"
                        }
                      >
                        <img src={UploadIcon} alt="img" />
                        <span className="uploadTextRegister">
                          {textContents.upload}
                        </span>
                        <input
                          className="input-group-text"
                          type="file"
                          onChange={(e) => {
                            setGuestPhoto(e.target.files[0].name);
                          }}
                        />
                      </label>

                      <button
                        className={
                          guestPhotoRequired == true
                            ? "cameraContainerGuest"
                            : "cameraContainerGuest uploadPhotoContainerGuestError"
                        }
                        onClick={() => {
                          // setIsCamera(true);
                          // setShow(true);
                          setModalOpenStatus(true);
                        }}
                      >
                        <img src={CameraIcon} alt="img" />
                        <span className="uploadTextRegister">
                          {textContents.camera}
                        </span>
                      </button>

                      <br />

                      <p className="imageNameGuest">{guestPhoto}</p>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="formFieldOuterContainerRegister">
                <div className="fieldOuterContainerRegister">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.contactNo}
                      </span>
                    </div>
                    <div
                      className={
                        contactNoRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={contactNo}
                        type={"number"}
                        maxLength={10}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-", "."].includes(e.key) &&
                          e.preventDefault()
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                        value={contactNo}
                        onChange={(e) => {
                          setContactNo(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.purpose} {textContents.visit}
                      </span>
                      {/* <span className="fieldNametextRegister">

                      </span> */}
                    </div>
                    <div
                      className={
                        purposeOfVisitRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={purposeOfVisit}
                        value={purposeOfVisit}
                        type={"text"}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^a-zA-Z\s]/gi, "");
                          setPurposeOfVisit(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.vehicleNo}
                      </span>
                    </div>
                    <div
                      className={
                        vehicleNoRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={vehicleNo}
                        value={vehicleNo}
                        type={"text"}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^a-zA-Z0-9-\s]/gi, "");
                          setVehicleNo(value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {/* {textContents.purpose}
                      </span>
                      <span className="fieldNametextRegister">
                        {textContents.visit} */}
                        assigned to
                      </span>
                    </div>
                    <div
                      className={
                        purposeOfVisitRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={assignedTo}
                        value={assignedTo}
                        type={"text"}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^a-zA-Z\s]/gi, "");
                          setAssignedTo(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        Upload ID Proof
                      </span>
                      {/* <span className="fieldNametextRegister"></span> */}
                    </div>
                    <div
                      className={
                        inavalidIdProof === true
                          ? "fieldValueExcelRegister"
                          : "fieldValueExcelRegisterError"
                      }
                      // className={
                      //   inavalidIdProof == false && !idORPhotoOptional
                      //     ? "fieldValueExcelRegisterError "
                      //     : "fieldValueExcelRegister"
                      // }
                    >
                      <label className="uploadPhotoContainerGuest uploadID-proof">
                        <img src={UploadIcon} alt="img" />
                        <span className="uploadTextRegister">
                          {textContents.upload}
                        </span>
                        <input
                          className="input-group-text"
                          type={"file"}
                          accept="image/jpeg, image/png, application/pdf"
                          onChange={(e) => {
                            let selectedFile = e?.target?.files[0];
                            const acceptedFiles = [
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ];
                            if (acceptedFiles.includes(selectedFile?.type)) {
                              setPdfFileLabel(e?.target?.files[0]?.name);
                              setIdProof(e.target.files[0]);
                            } else {
                              setIdProof("");
                              setPdfFileLabel("");
                            }
                          }}
                        />
                      </label>
                      {console.log("aaa", pdfFileLabel)}
                      {pdfFileLabel == "" ? (
                        <p className="guestListUpload">PNG, JPEG, PDF Format</p>
                      ) : (
                        <p className="guestListUpload">{pdfFileLabel}</p>
                      )}
                      {/* <p className="guestListUpload">pf{pdfFileLabel}</p>
                      <br />
                      <p className="guestListUpload">pl{idProof}</p> */}
                    </div>
                  </div>
                </div>

                {/* <div className="fieldOuterContainerRegister">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.addPhoto}
                      </span>
                    </div>
                    <div className="fieldValuePhotoRegister">
                      <label
                        className={
                          guestPhotoRequired == true
                            ? "uploadPhotoContainerGuest"
                            : "uploadPhotoContainerGuest uploadPhotoContainerGuestError"
                        }
                      >
                        <img src={UploadIcon} alt="img" />
                        <span className="uploadTextRegister">{textContents.upload}</span>
                        <input
                          className="input-group-text"
                          type={"file"}
                          onChange={(e) => {
                            setGuestPhoto(e.target.files[0].name);
                          }}
                        />
                      </label>

                      <button
                        className={
                          guestPhotoRequired == true
                            ? "cameraContainerGuest"
                            : "cameraContainerGuest uploadPhotoContainerGuestError"
                        }
                        onClick={() => {
                          // setIsCamera(true);
                          // setShow(true);
                          setModalOpenStatus(true);
                        }}
                      >
                        <img src={CameraIcon} alt="img" />
                        <span className="uploadTextRegister">{textContents.camera}</span>
                      </button>

                      <br />

                      <p className="imageNameGuest">{guestPhoto}</p>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="formFieldOuterContainerRegister">
                <div className="fieldOuterContainerRegister">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextCategory">
                        {textContents.category}
                      </span>
                    </div>
                    <div className="fieldValueRegister">
                      {/* <DropDownItem
                        selectedItem={category}
                        setSelectedItem={setCategory}
                        list={categoryList}
                        categoryRequired={categoryRequired}
                      /> */}
                      <div className="categoryContainer">
                        <span className="visitor-name">{category?.name}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.location}
                      </span>
                    </div>
                    <div
                      className={
                        locationRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={location}
                        value={location}
                        type={"text"}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^A-Za-z]/gi, "");
                          setLocation(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        {textContents.fromPlace}
                      </span>
                    </div>
                    <div
                      className={
                        fromPlaceRequired == true
                          ? "fieldValueRegister"
                          : "fieldValueRegister fieldRequiredRegister"
                      }
                    >
                      <TextInput
                        placeholder={fromPlace}
                        value={fromPlace}
                        type={"text"}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^A-Za-z]/gi, "");
                          setFromPlace(value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* {guestType == "G" ? (
                  <div className="fieldOuterContainerRegister">
                    <div className="fieldInnerContainerRegister">
                      <div className="fieldNameRegister">
                        <span className="fieldNametextRegister">{textContents.uploadExcel}</span>
                      </div>
                      <div
                        className={
                          guestListRequired == true
                            ? "fieldValueExcelRegister"
                            : "fieldValueExcelRegisterError "
                        }
                      >
                        <label className="uploadPhotoContainerGuest">
                          <img src={UploadIcon} alt="img" />
                          <span className="uploadTextRegister">{textContents.upload}</span>
                          <input
                            className="input-group-text"
                            type={"file"}
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={(e) => {
                              let selectedFile = e.target.files[0];
                              const acceptedFiles = [
                                ".csv",
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                "application/vnd.ms-excel",
                              ];
                              if (selectedFile && acceptedFiles.indexOf(selectedFile.type) === -1) {
                                setGuestList("");
                              } else {
                                setGuestList(e.target.files[0].name);
                              }
                            }}
                          />
                        </label>
                        <p className="guestListUpload">{guestList}</p>
                      </div>
                    </div>
                  </div>
                ) : null} */}
                <div className="fieldOuterContainerRegister field-margin-top">
                  <div className="fieldInnerContainerRegister">
                    <div className="fieldNameRegister">
                      <span className="fieldNametextRegister">
                        Visitor Type*
                      </span>
                    </div>
                    <div className="fieldValueRegister">
                      <DropDownItem
                        selectedItem={visitorType}
                        setSelectedItem={setVisitorType}
                        list={visitorTypeList}
                        categoryRequired={visitorTypeRequired}
                      />
                    </div>
                  </div>
                </div>

                <div className="fieldOuterContainerRegister">
                  {guestType == "G" ? (
                    <div className="fieldOuterContainerRegister field-margin-top">
                      <div className="fieldInnerContainerRegister">
                        <div className="fieldNameRegister">
                          <span className="fieldNametextRegister">
                            {textContents.uploadExcel}
                          </span>
                        </div>
                        <div
                          className={
                            guestListRequired == true
                              ? "fieldValueExcelRegister"
                              : "fieldValueExcelRegisterError"
                          }
                        >
                          <label className="uploadPhotoContainerGuest">
                            <img src={UploadIcon} alt="img" />
                            <span className="uploadTextRegister">
                              {textContents.upload}
                            </span>
                            <input
                              className="input-group-text"
                              type={"file"}
                              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                              onChange={(e) => {
                                let selectedFile = e?.target?.files?.[0];
                                const acceptedFiles = [
                                  ".csv",
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  "application/vnd.ms-excel",
                                ];
                                if (
                                  selectedFile &&
                                  acceptedFiles.indexOf(selectedFile.type) ===
                                    -1
                                ) {
                                  setGuestList("");
                                } else {
                                  setGuestList(e?.target?.files?.[0]);
                                }
                              }}
                            />
                          </label>
                          <p className="guestListUpload mt-1">
                            {guestList?.name || guestList}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="fieldOuterContainerRegister"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 buttonOuterContainerGuestRegister">
            <Button text={textContents.cancel} onClick={() => goBack()} />

            <div className="ms-2">
              <Button
                text={
                  visitorSpinnerStatus ? (
                    <Spinner size="sm" />
                  ) : (
                    textContents.save
                  )
                }
                onClick={() => {
                  validateGuestRegister();
                }}
              />
            </div>
          </div>
        </div>
      </Container>
      <CameraUpload
        show={modalOpenStatus}
        setShow={setModalOpenStatus}
        isCamera={isCamera}
        setIsCamera={setIsCamera}
        setVisitorPhoto={setGuestPhoto}
        visitorPhoto={guestPhoto}
        photoLabel={cameraLabel}
      />
    </div>
  );
};

export default GuestRegisterPage;
